import cn from 'classnames';
import { FC } from 'react';

import { Layout } from '@/shared/ui';

import { Header } from '@/widgets/Header';

import styles from '../../Encounters.module.scss';
import { UseEncountersPageResult } from '../../hooks';
import { EncounterDetails } from '../EncounterDetails/EncounterDetails';

import { EncountersListPane } from './EncountersListPane';

type EncountersDesktopLayoutProps = UseEncountersPageResult & {
  className?: string;
};

export const EncountersDesktopLayout: FC<EncountersDesktopLayoutProps> = (
  props,
) => {
  const {
    approveDocument,
    attachPatient,
    className,
    fetchedEncounterError,
    fetchedEncounterLoading,
    scrollContainerRef,
    selectedEncounter,
    ...listProps
  } = props;

  return (
    <Layout>
      <Layout.Header>
        <Header />
      </Layout.Header>
      <Layout.Content data-section="encounters">
        <Layout.Main>
          <div className={cn(styles.container, className)}>
            <aside
              ref={scrollContainerRef}
              className={styles.sidebar}
              data-section="encounters-list"
            >
              <EncountersListPane {...listProps} />
            </aside>
            <section
              className={styles.details}
              data-section="encounters-details"
            >
              <EncounterDetails
                encounter={selectedEncounter}
                loading={fetchedEncounterLoading}
                error={fetchedEncounterError}
                onApproveDocument={approveDocument}
                onAttachPatient={attachPatient}
              />
            </section>
          </div>
        </Layout.Main>
      </Layout.Content>
    </Layout>
  );
};
